/**
 * A dónde mandar a alguien después de entrar.
 *
 * POR QUÉ EXISTE
 * ==============
 *
 * El guardia de rutas hacía `Navigate to="/login"` y **tiraba el destino**. El
 * vendedor recibe por WhatsApp el enlace a una conversación, no tiene sesión en
 * el teléfono, se identifica… y aterriza en el tablero. Tiene que buscar el
 * prospecto a mano — que es exactamente la fricción que el aviso venía a quitar,
 * solo que movida un paso más adelante.
 *
 * POR QUÉ SE SANEA, Y NO ES PARANOIA
 * ==================================
 *
 * Si el destino se acepta tal cual, cualquiera puede mandar
 *
 *     https://app.cavernicolapp.com/login?volver=https://sitio-del-atacante.mx
 *
 * El enlace es NUESTRO, el candado del navegador es el nuestro, la persona se
 * identifica de verdad… y acto seguido la soltamos en la página de otro, recién
 * autenticada y confiada. Se llama redirección abierta y es de las más viejas
 * que hay.
 *
 * Por eso solo se aceptan rutas de dentro. Y se comprueba de tres formas,
 * porque cada una sola se puede burlar:
 *
 *   * `//otro.com` — el navegador lo lee como «mismo protocolo, OTRO dominio».
 *     Empieza por `/`, así que un `startsWith('/')` a secas lo deja pasar.
 *   * `/\otro.com` — varios navegadores tratan la barra invertida como barra.
 *   * `http://…` en medio, o `javascript:`.
 */

/** El destino por omisión de cada figura. Es lo que había antes de todo esto. */
export function destinoPorOmision(user) {
  if (!user) return '/login';
  if (user.user_type === 'partner') return '/socio';
  if (user.user_type === 'platform') return user.tenant_id ? '/tenant' : '/admin';
  return '/tenant';
}

/** ¿Es una ruta interna que podemos abrir sin riesgo? */
export function esDestinoInterno(destino) {
  if (typeof destino !== 'string' || !destino) return false;
  const d = destino.trim();
  if (!d.startsWith('/')) return false;      // absoluta o relativa rara
  if (d.startsWith('//')) return false;      // «mismo protocolo, otro dominio»
  if (d.includes('\\')) return false;        // la barra invertida cuela como barra
  if (d.includes('://')) return false;       // un esquema metido en medio
  // eslint-disable-next-line no-script-url
  if (/^\/*\s*javascript:/i.test(d)) return false;
  // Volver al propio login sería un bucle.
  if (d === '/login' || d.startsWith('/login?')) return false;
  return true;
}

/**
 * El destino final: el pedido si es de fiar, y si no el de siempre.
 *
 * Nunca devuelve algo de fuera: ante la duda, manda a casa. Perder un salto es
 * una molestia; soltar a alguien recién identificado en la página de otro no.
 */
export function destinoTrasEntrar(user, destinoPedido) {
  return esDestinoInterno(destinoPedido) ? destinoPedido : destinoPorOmision(user);
}

/** La URL del login que recuerda de dónde venías. */
export function loginQueRecuerda(rutaActual) {
  if (!esDestinoInterno(rutaActual)) return '/login';
  return `/login?volver=${encodeURIComponent(rutaActual)}`;
}
